<template>
    <div>
      <Header></Header>
      
      <keep-alive>
          <router-view v-if="this.$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!this.$route.meta.keepAlive"></router-view>
      <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'

export default {
  name: 'PageView',
  components: {
    Header,
    Footer
  },
}
</script>

<style scoped>

</style>